import React, { Children } from 'react';

import { cssMap } from '@atlaskit/css';
import { Grid } from '@atlaskit/primitives/compiled/grid';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	root: {
		gridTemplateColumns: '1fr',
		gap: token('space.100'),

		'@media (min-width: 30rem)': {
			gridTemplateColumns: '1fr 1fr',
			gap: token('space.200'),
		},
	},
});

/**
 * __Related card grid__
 *
 * Displays `RelatedCard`s in a grid layout.
 */
const RelatedCardGrid = ({ children }: { children: React.ReactNode }): React.JSX.Element => {
	return (
		<Grid xcss={styles.root}>
			{Children.map(children, (child) => (
				<div>{child}</div>
			))}
		</Grid>
	);
};

export default RelatedCardGrid;
